// utils/menuList.js
export const getMenuList = (
  getText,
  permissions = [],
  dynamicModules = [],
  userRoleId = null,
  visibleMenuKeys = [], // navigation_items tablosundaki key’ler
) => {
  /* —————————————————— Yardımcılar —————————————————— */
  const role = (localStorage.getItem("userRole") || "").toLowerCase();

  const isSuperAdmin = role === "superadmin";

  console.log("%c[ML] ➜ ÇAĞRILDI", "background:#004; color:#fff", {
    dynLen: dynamicModules.length,
    permLen: permissions.length,
  });

  // Statik menüler için (module_key ile)
  const getPerm = (key) => permissions.find((p) => p.module_key === key) || {};

  // Dinamik modüller için (module_id ile) ← YENİ
  const getPermByModuleId = (moduleId) =>
    permissions.find((p) => p.module_id === moduleId) || {};

  const isVisible = (key) => isSuperAdmin || visibleMenuKeys.includes(key);

  /* —————————————————— 1) ÜST MENÜ —————————————————— */
  const staticTop = [
    {
      id: 0,
      name: getText("MENU_DASHBOARD"),
      path: "/",
      icon: "device-desktop.svg",
      dropdownMenu: false,
    },
    { isDivider: true },
  ];

  /* —————————————————— 2) DİNAMİK MODÜLLER —————————————————— */
  const dynamicMenu = dynamicModules
    .filter((m) => m.is_visible !== 0)
    .flatMap((m) => {
      const prm = getPermByModuleId(m.id); // ✅ module_id ile eşleştir
      console.log(`[DYN] ${m.name} (id:${m.id})`, prm); // debug için

      return isSuperAdmin || prm.full_access || prm.sort_permission
        ? [
          {
            id: m.id,
            name: m.name,
            path: `/modules/${m.multiple_slug}`,
            icon: m.icon || "file.svg",
            dropdownMenu: false,
          },
        ]
        : [];
    });

  /* —————————————————— 3) STATİK MENÜLER —————————————————— */
  const cleanDividersWithKeep = (menuArray, keepBeforeIds = []) => {
    const cleaned = [];

    for (let i = 0; i < menuArray.length; i++) {
      const item = menuArray[i];
      const prev = cleaned[cleaned.length - 1];

      // Divider ise:
      if (item?.isDivider) {
        const next = menuArray[i + 1];

        // Eğer hem önce hem sonra içerik yoksa ya da önceki de divider ise: atla
        if (!prev || prev.isDivider || !next || next.isDivider) {
          continue;
        }

        // Eğer kendisinden sonra gelen önemli bir menü (örneğin Geliştirici Ayarları) varsa koru
        if (next?.id && keepBeforeIds.includes(next.id)) {
          cleaned.push(item);
          continue;
        }

        // Normal kontrol: geçerli bir öğe varsa ekle
        if (prev && next) cleaned.push(item);
        continue;
      }

      // Normal öğeleri ekle
      if (item) cleaned.push(item);
    }

    return cleaned;
  };

  const dynamicMenuWithDivider = [...dynamicMenu];
  if (dynamicMenu.length > 0) {
    dynamicMenuWithDivider.push({ isDivider: true });
  }

  //‑‑‑ HELP CENTER öğesini önce tek değişkende kuralım
  const helpCenterItem =
    isVisible("static_help_center") &&
      (isSuperAdmin || getPerm("static_help_center").sort_permission)
      ? {
        id: 17,
        name: getText("MENU_HELP_CENTER"),
        path: "#",
        icon: "lifebuoy.svg",
        dropdownMenu: [
          {
            id: 1,
            name: getText("MENU_HELP_SUPPORT"),
            path: "/help/knowledgebase",
            subdropdownMenu: false,
          },
          // Versiyon menüsü koşullu eklenir
          isVisible("static_version") &&
          (isSuperAdmin || getPerm("static_version").sort_permission) && {
            id: 2,
            name: getText("MENU_HELP_VERSION"),
            path: "/version/list",
            subdropdownMenu: false,
          },
        ].filter(Boolean),
      }
      : null;

  const staticBottom = [
    isVisible("static_users") &&
    (isSuperAdmin || getPerm("static_users").sort_permission) && {
      id: 3,
      name: getText("MENU_USERS"),
      path: "/customers/list",
      icon: "users.svg",
      dropdownMenu: false,
    },

    { isDivider: true },

    isVisible("static_admin_accounts") &&
    (isSuperAdmin || getPerm("static_admin_accounts").sort_permission) && {
      id: 10,
      name: getText("MENU_ADMINS"),
      path: "#",
      icon: "user-shield.svg",
      dropdownMenu: [
        {
          id: 1,
          name: getText("MENU_ADMINS_LIST"),
          path: "/leads/list",
          subdropdownMenu: false,
        },
        isVisible("static_roles") &&
        (isSuperAdmin || getPerm("static_roles").sort_permission) && {
          id: 2,
          name: getText("MENU_ROLES"),
          path: "/admin/roles",
          subdropdownMenu: false,
        },
      ].filter(Boolean),
    },

    { isDivider: true },

       isVisible("static_users") &&
    (isSuperAdmin || getPerm("static_users").sort_permission) && {
      id: 4,
      name: "Yönetim",
      path: "/management-table",
      icon: "adjustments.svg",
      dropdownMenu: false,
    },

    { isDivider: true },
    isVisible("static_admin_accounts") &&
    (isSuperAdmin || getPerm("static_admin_accounts").sort_permission) && {
      id: 18,
      name: "menü ayarlama",
      path: "/custom-switch-page",
      icon: "menu-2.svg",
      dropdownMenu: false,
    },

    /* ——— GELİŞTİRİCİ AYARLARI ——— */
    { isDivider: true },

    isVisible("static_developer_settings") &&
    (isSuperAdmin ||
      getPerm("static_developer_settings").sort_permission) && {
      id: 15,
      name: getText("MENU_DEVELOPER_SETTINGS"),
      path: "#",
      icon: "api-app.svg",
      dropdownMenu: [
        isVisible("static_language_options") &&
        (isSuperAdmin ||
          getPerm("static_admin_accounts").sort_permission) && {
          id: 1,
          name: getText("MENU_LANGUAGE_OPTIONS"),
          path: "/admin/language",
          subdropdownMenu: false,
        },

        isVisible("static_site_redirect") &&
        (isSuperAdmin ||
          getPerm("static_admin_accounts").sort_permission) && {
          id: 2,
          name: getText("MENU_SITE_REDIRECT"),
          path: "/admin/website",
          subdropdownMenu: false,
        },
        isVisible("static_module") &&
        (isSuperAdmin ||
          getPerm("static_admin_accounts").sort_permission) && {
          id: 3,
          name: getText("MENU_MODULES"),
          path: "/admin/modules/list",
          subdropdownMenu: false,
        },
        isVisible("static_navigate") &&
        (isSuperAdmin ||
          getPerm("static_admin_accounts").sort_permission) && {
          id: 4,
          name: getText("MENU_NAVIGATE_MENU"),
          path: "/admin/navigation/status",
          subdropdownMenu: false,
        },
        isVisible("static_navigate") &&
        (isSuperAdmin ||
          getPerm("static_admin_accounts").sort_permission) && {
          id: 5,
          name: getText("FOOTER_COMPANY_LOGO_LABEL"),
          path: "/admin/footer/logo",
          subdropdownMenu: false,
        },
      ].filter(Boolean),
    },

    /* ——— SİSTEM AYARLARI ——— */
    { isDivider: true },

    isVisible("static_admin_accounts") && {
      id: 16,
      name: getText("MENU_SETTINGS"),
      path: "/settings/ganeral",
      icon: "settings.svg",
      dropdownMenu: false,
    },

    /* ——— HELP CENTER (koşullu) ——— */
    helpCenterItem,
  ].filter(Boolean);

  /* —————————————————— 4) DÖNÜŞ —————————————————— */
  const fullMenu = [...staticTop, ...dynamicMenuWithDivider, ...staticBottom];

  return cleanDividersWithKeep(fullMenu, [14]);
};
